const Footer = () => {
  return (
    <div>
      <section className="relative section-frame palast-variable-italic flex-all-center oveflow-x-hidden">
        <div className="triangle-footer"></div>
        <div className="w-full flex flex-col justify-center items-center overflow-x-hidden">
          <p className="z-[5] KinutaShinStdN48K pl-[40px] string-big flex-all-center tracking-[20px]">
            DAWN
          </p>
        </div>
      </section>
      <section className="shootingstar-underline bg-[#0D081A] h-[50px] w-full flex-all-center kinuta-maruminfuji-stdn string-s2">
        Copyright 2024 - Dawn. All Rights Reserved.
      </section>
    </div>
  );
};

export default Footer;
